import type { PortfolioAdminDetail } from '@repo/api-contracts';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { PublishedProductPicker } from '@/entities/product';
import { movedOrder } from '@/shared/lib';
import { Button } from '@/shared/ui';
import { PortfolioLinkedProduct } from './portfolio-linked-product';

export const PortfolioProductField = ({
  ids,
  existingProducts = [],
  disabled,
  onChange,
}: {
  ids: string[];
  existingProducts?: PortfolioAdminDetail['products'];
  disabled?: boolean;
  onChange: (ids: string[]) => void;
}) => {
  const [isOpen, setOpen] = useState(false);
  const move = (from: number, to: number) => {
    if (!disabled) onChange(movedOrder(ids, from, to));
  };
  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-medium">포함 상품</h2>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          상품 선택
        </Button>
      </div>
      {ids.length === 0 ? (
        <p className="text-sm text-muted-foreground">연결된 상품이 없습니다.</p>
      ) : (
        <ul className="space-y-2">
          {ids.map((id, index) => (
            <PortfolioLinkedProduct
              key={id}
              id={id}
              existing={existingProducts.find((product) => product.id === id)}
              index={index}
              count={ids.length}
              disabled={disabled}
              onMove={move}
              onRemove={() => {
                if (!disabled) onChange(ids.filter((value) => value !== id));
              }}
              onDropProduct={(source, target) => {
                const from = ids.indexOf(source);
                if (from >= 0 && from !== target) move(from, target);
              }}
            />
          ))}
        </ul>
      )}
      {isOpen
        ? createPortal(
            <PublishedProductPicker
              title="포함 상품 선택"
              description="공개된 상품을 선택한 순서로 연결합니다."
              linkedLabel="선택됨"
              linkedProductIds={ids}
              isAddDisabled={Boolean(disabled)}
              isPending={false}
              errorMessage={null}
              onAdd={(id) => {
                if (!disabled && !ids.includes(id)) onChange([...ids, id]);
              }}
              onClose={() => setOpen(false)}
            />,
            document.body,
          )
        : null}
    </section>
  );
};
